// Import model
import { FilterCarpetCatalogItemRequest } from '../models/FilterCarpetCatalogItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CarpetCatalogItemCondition } from '../models/CarpetCatalogItemCondition';
import { CarpetCatalogItemFields } from '../models/CarpetCatalogItemFields';
import { CarpetCatalogItemIndexedFields } from '../models/CarpetCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { CarpetCatalogItemConditionSerializer } from './CarpetCatalogItemConditionSerializer';
import { CarpetCatalogItemFieldsSerializer } from './CarpetCatalogItemFieldsSerializer';
import { CarpetCatalogItemIndexedFieldsSerializer } from './CarpetCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCarpetCatalogItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCarpetCatalogItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCarpetCatalogItemRequest instance
   */
  static deserialize(json: string): FilterCarpetCatalogItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCarpetCatalogItemRequest instance
   */
  static fromObject(obj: any): FilterCarpetCatalogItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCarpetCatalogItemRequest');
    }


    const instance: FilterCarpetCatalogItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CarpetCatalogItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CarpetCatalogItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CarpetCatalogItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCarpetCatalogItemRequest instances
   */
  static deserializeArray(json: string): FilterCarpetCatalogItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCarpetCatalogItemRequest instance to a JSON string
   */
  static serialize(instance: FilterCarpetCatalogItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCarpetCatalogItemRequest instance to a plain object
   */
  static toObject(instance: FilterCarpetCatalogItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CarpetCatalogItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCarpetCatalogItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCarpetCatalogItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
